<template>
  <input type="hidden" :name="name" v-model="value">
</template>

<script>

export default {
  props: ['name', 'default'],
  data () {
    return {
      value: null
    }
  },
  created: function () {
  },
  mounted: function () {
    this.initialize();
  },
  watch: {
    '$route' () {
      this.initialize();
    },
    default: function () {
      this.initialize();
    }
  },
  methods: {
    initialize: function () {

      if (this.default) {

        let value = {key: this.name, value: this.default};

        this.$store.dispatch('formValues/setFormData', value).then();
      }

      this.value = this.default;

    }
  }
}

</script>
